<template>
	<div class="kitchen-scene-simulation">
		<img src="@/assets/imgs/bg/kitchen-device.png" />
		<div
			class="sub-device"
			v-for="item in subDeviceList"
			:key="item.subDeviceType"
			:style="{ top: item.y, left: item.x }"
			:class="{ disabled: item.disabled, open: openSubTypeList.includes(item.subDeviceType) }"
		>
			<div class="sub-device-name" :class="{ disabled: item.disabled }">{{ item.subDeviceName }}</div>
			<div class="join-line" :class="[item.linePosition]"></div>
			<div class="detail-modal" v-if="item.detail && !item.disabled" :style="item.detail.style">
				<div class="detail-item" v-for="itemName in item.detail.data" :key="itemName.key">
					<div class="label">{{ itemName.label }}</div>
					<div class="value">{{ itemName.value }}</div>
				</div>
				<span
					class="go-details"
					v-if="item.detail.showDeviceDetailsBtn"
					@click="handleToDeviceDetails(item.deviceId, item.deviceTypeId)"
				>
					设备详情
				</span>
				<div class="arrow" :style="item.detail.arrow.style"></div>
			</div>
		</div>
	</div>
</template>

<script>
import { apiGetKitchenRoomDeviceDetails } from '@/apis/account.api'
import subDeviceList from './subDevice'
export default {
	data() {
		return {
			subDeviceList,
			openSubTypeList: [],
		}
	},
	created() {
		this.getKitchenRoomDeviceDetails()
	},

	methods: {
		async getKitchenRoomDeviceDetails() {
			const dataList = await apiGetKitchenRoomDeviceDetails(this.iotDeviceId)
			this.subDeviceList.forEach(m => {
				const t = dataList.find(n => n.subDeviceType === m.subDeviceType)
				if (t) {
					m.detail.data.forEach(k => {
						this.$set(k, 'value', t[k['key']] || '-')
					})
					this.openSubTypeList.push(m.subDeviceType)
					if (m.detail.showDeviceDetailsBtn) {
						this.$set(m, 'deviceId', t.deviceId)
						this.$set(m, 'deviceTypeId', t.deviceTypeId)
					}
				} else {
					this.$set(m, 'disabled', true)
				}
			})
		},

		async handleToDeviceDetails(deviceId, deviceTypeId) {
			this.$router.push({
				path: '/device/detail',
				query: {
					deviceId: deviceId,
					deviceType: deviceTypeId,
				},
			})
		},
	},

	computed: {
		iotDeviceId() {
			return this.$route.query.iotDeviceId
		},
	},
}
</script>
<style lang="scss" scoped>
.kitchen-scene-simulation {
	height: 100%;
	position: relative;
	width: fit-content;
	margin: 0 auto;
	img {
		display: block;
		height: 100%;
	}
	.sub-device {
		position: absolute;
		transform: translate(-50%, -50%);
		&.disabled {
			opacity: 0.7;
			cursor: not-allowed;
		}

		&.open {
			.sub-device-name {
				color: #ffffff;
				background-color: #436beb;
				border-color: #fff;
			}
		}

		.sub-device-name {
			color: #fff;
			border-radius: 20px;
			border: 2px solid #c0c7e2;
			line-height: 24px;
			padding: 4px 20px;
			background-color: #00000080;
			font-size: 13px;
			user-select: none;
			cursor: pointer;
			&:not(.disabled):hover {
				color: #ffffff;
				background-color: #436beb;
				border-color: #fff;
			}
			&.disabled {
				cursor: not-allowed;
			}
		}

		.join-line {
			position: absolute;
			width: 2px;
			height: 16px;
			background-color: #fff;
			left: 50%;
			margin-left: -1px;
			&:after {
				content: '';
				width: 4px;
				height: 4px;
				border-radius: 50%;
				background-color: #000;
				border: 2px solid #fff;
				position: absolute;
				left: -3px;
			}
			&.bottom {
				bottom: -16px;
				&::after {
					bottom: -6px;
				}
			}
			&.top {
				top: -16px;
				&::after {
					top: -4px;
				}
			}
		}

		.detail-modal {
			position: absolute;
			padding: 12px;
			border-radius: 6px;
			background-color: #436beb;
			text-align: right;
			.detail-item {
				display: flex;
				align-items: center;
				padding: 8px 12px;
				white-space: nowrap;
				.label {
					margin-right: 12px;
					color: #ffffffde;
				}
				.value {
					color: #fff;
				}
			}
			.arrow {
				position: absolute;
				border-top: 8px solid transparent;
				border-right: 8px solid #436beb;
				border-bottom: 8px solid transparent;
				border-left: 8px solid transparent;
			}

			.go-details {
				margin-right: 8px;
				margin-top: 8px;
				display: inline-block;
				border: 1px solid #fff;
				padding: 6px 12px;
				font-size: 12px;
				color: #fff;
				border-radius: 24px;
				cursor: pointer;
				user-select: none;
				white-space: nowrap;
			}
		}

		@media (max-width: 1566px) {
			.sub-device-name {
				font-size: 12px;
				padding: 2px 12px;
			}

			.join-line {
				height: 10px;
				&:after {
					content: '';
					width: 2px;
					height: 2px;
					border: 2px solid #fff;
					left: -2px;
				}
				&.bottom {
					bottom: -10px;
				}
				&.top {
					top: -10px;
				}
			}

			.detail-modal {
				padding: 8px;
				.detail-item {
					padding: 6px 10px;
					font-size: 12px;
					.label {
						margin-right: 10px;
					}
					.value {
						color: #fff;
					}
				}
			}
		}
	}
}
</style>
